import { useState } from 'react'
import { Input } from './Input.js'
import { Div } from './flags.js'
import { send_data, update_data, delete_data } from './data.js'
import { array, get_today_date, get_new_id } from './toolbox.js'
import * as defs from './defs/Faturas.defs.js'

export const Category = (props) => {
  const { faturas, set_faturas, set_selected, category, mode } = props
  const Faturas = (mode === 'grid' && Grid) || Div
  const registered_category = category === 'registered'
  const filtered_faturas = faturas
    .filter(
      ({ registered, status }) =>
        (registered_category && registered) ||
        (!registered && status === category),
    )
    .sort((a, b) => new Date(a.date) - new Date(b.date))

  return (
    <Container>
      <Section
        grey3={registered_category}
        b_grey2={registered_category}
        sapphire4={!registered_category}
        b_sapphire2={!registered_category}
      >
        {category}
      </Section>
      <Faturas>
        {filtered_faturas.map((fatura, i) => (
          <Fatura
            key={fatura.id}
            fatura={fatura}
            faturas={faturas}
            set_faturas={set_faturas}
            set_selected={set_selected}
            mode={mode}
          />
        ))}
        <NewFatura
          category={category}
          mode={mode}
          faturas={faturas}
          set_faturas={set_faturas}
        />
        {Placeholders}
      </Faturas>
    </Container>
  )
}

const NewFatura = ({ category, mode, faturas, set_faturas }) => {
  const grid = mode === 'grid'
  const rows = mode === 'rows'
  const Container = (grid && Card) || (rows && Row)

  return (
    <Container
      c_pointer
      bb0={rows}
      fs50={grid}
      mt20={rows}
      grey5={grid}
      jc_center={grid}
      w_fit_content={rows}
      onClick={() => {
        const id = get_new_id(faturas)
        const created_at = new Date()
        const registered = category === 'registered'
        const status = !registered ? category : 'unregistered'
        const date = get_today_date()
        const scope = 'perso'
        const new_fatura = { id, created_at, date, status, registered, scope }
        send_data('post', 'faturas', set_faturas, new_fatura)
      }}
    >
      +{rows && <Add>New fatura</Add>}
    </Container>
  )
}

const Fatura = ({ fatura, faturas, set_faturas, set_selected, mode }) => {
  const [display, set_display] = useState(false)
  const { date, scope, registered, id } = fatura
  const grid = mode === 'grid'
  const rows = mode === 'rows'
  const perso = scope === 'perso'
  const Container = (grid && Card) || (rows && Row)

  return (
    <Container
      id={`fatura-${id}`}
      onClick={({ target }) => {
        target.id === `fatura-${id}` && set_selected(fatura)
      }}
      onMouseOver={() => set_display(true)}
      onMouseLeave={() => set_display(false)}
      relative
    >
      <Delete
        b0={grid}
        pb10={grid}
        pv10={rows}
        o100={display}
        style={{ left: rows && '-70px', top: rows && '12px' }}
        onClick={() => delete_data(`faturas/${id}`, set_faturas)}
      >
        ×
      </Delete>
      <Infos order1={grid} order3={rows} flex2={rows}>
        <DatePicker flex1={rows}>
          <Day
            value={date}
            type="date"
            onChange={({ target }) =>
              update_data(`faturas/${id}`, set_faturas, { date: target.value })
            }
          />
          <Hider style={{ top: '-3px', left: '42px' }} />
        </DatePicker>
        <Scope
          o30={perso}
          flex1={rows}
          onClick={() => {
            const current_index = scopes.indexOf(scope)
            const end_of_array = current_index === scopes.length - 1
            const next_index = end_of_array ? 0 : current_index + 1
            update_data(`faturas/${id}`, set_faturas, {
              scope: scopes[next_index],
            })
          }}
        >
          {(perso && 'pro') || scope}
        </Scope>
      </Infos>
      {Object.entries(inputs).map((input) => (
        <Input
          key={input[0]}
          input={input}
          mode={mode}
          data={fatura}
          datas={faturas}
          set_datas={set_faturas}
          data_type="faturas"
        />
      ))}
      <Registration
        id={id}
        mb10={grid}
        registered={registered}
        set_faturas={set_faturas}
      />
    </Container>
  )
}

const Registration = ({ id, registered, set_faturas, ...props }) => (
  <Button
    onClick={() =>
      update_data(`faturas/${id}`, set_faturas, { registered: !registered })
    }
    {...props}
  >
    {registered && 'un'}register
  </Button>
)

const { Section, Button } = defs
const { Container, Row, Grid, Card, Infos, Add, Delete } = defs
const { DatePicker, Day, Hider, Scope, Name, Seller, Price } = defs
const Placeholders = array(5).map((e) => <Div key={e} w15p />)

const scopes = ['pro', 'semi', 'perso']
const inputs = {
  name: {
    component: Name,
    placeholder: 'Groceries',
    classes: { grid: ['order2', 'fs22', 'mt20'], rows: ['order1', 'flex1'] },
  },
  seller: {
    component: Seller,
    placeholder: 'Glovo',
    classes: {
      grid: ['order3', 'mb20', 'mt10', 'h30'],
      rows: ['order2', 'flex2', 'h20'],
    },
  },
  amount: {
    component: Price,
    placeholder: '19.99',
    classes: { grid: ['mb20'], rows: ['flex1'] },
  },
}
